import { useNavigate, useLocation } from 'react-router-dom';
import { Paper, BottomNavigation, BottomNavigationAction } from '@mui/material';
import { Speed as SpeedIcon, LocalGasStation as FuelIcon, Build as MaintenanceIcon, Home as HomeIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const DriverFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('driver');

  // Extraire la dernière partie du chemin pour la valeur active
  const getCurrentValue = () => {
    const path = location.pathname.split('/').pop();
    if (!path || path === 'driver') return 'home';
    return path;
  };

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        zIndex: 1000
      }} 
      elevation={3}
    >
      <BottomNavigation
        value={getCurrentValue()}
        onChange={(_, newValue) => {
          navigate(newValue === 'home' ? '/driver' : `/driver/${newValue}`);
        }}
        showLabels
      >
        <BottomNavigationAction
          label={t('menu.home')}
          value="home"
          icon={<HomeIcon />}
        />
        <BottomNavigationAction
          label={t('menu.mileage')}
          value="mileage"
          icon={<SpeedIcon />}
        />
        <BottomNavigationAction
          label={t('menu.fuel')}
          value="fuel"
          icon={<FuelIcon />}
        />
        <BottomNavigationAction
          label={t('menu.maintenance')}
          value="maintenance"
          icon={<MaintenanceIcon />}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default DriverFooter;